import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import {
  useGetInventoryItemsRequest,
  useGetInventoryByIdRequest,
} from '../../hooks/useApi';

export const useInventoryReport = () =>
{
  const { inventoryId } = useParams();
  const changeStoreParams = JSON.parse(localStorage.getItem('changeStoreParams'));
  const posId = changeStoreParams?.selectedPosId;

  const [{ data, loading, error }, getInventoryItems] = useGetInventoryItemsRequest(posId);
  const [{ data: inventoryData }, getInventoryById] = useGetInventoryByIdRequest(posId);

  useEffect(() =>
  {
    if (inventoryId && posId)
    {
      getInventoryItems({ bodyParams: { inventoryId: parseInt(inventoryId, 10) } });
      getInventoryById({ queryParams: { inventoryId: parseInt(inventoryId, 10) } });
    }
  }, [inventoryId, posId]); // eslint-disable-line react-hooks/exhaustive-deps

  const items = useMemo(() =>
  {
    if (!Array.isArray(data)) return [];
    return data.map(item => ({
      ...item,
      style: (item.modelCode && item.fabricCode) ? `${item.modelCode}${item.fabricCode}` : null,
    }));
  }, [data]);

  const parsedInventory = inventoryData
    ? (typeof inventoryData === 'string' ? JSON.parse(inventoryData) : inventoryData)
    : null;

  const total = items.length;
  const resolved = items.filter(i => i.status !== 'PENDING').length;
  const issues = items.filter(i => i.status === 'PENDING').length;
  const remaining = issues;

  return {
    inventoryId,
    posId,
    inventory: parsedInventory,
    items,
    total,
    issues,
    resolved,
    remaining,
    loading,
    error,
  };
};
